// extracted by mini-css-extract-plugin
export default {"wrapper":"qA-z","viewport":"rA-z","container":"sA-z","slide":"tA-z"};